import { useParams } from 'react-router-dom';
import ModalDialog, {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { useForm } from 'src/components/Form';
import { useAlert, AlertType } from 'src/components/AlertsProvider';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { generateApiPath } from 'src/utils';
import { API_POST_RULE_CONFIGURATION } from '../../constants';
import { useCurrentSolutionName } from '../../redux';
import { SolutionRuleConfigurationItem } from '../../types/solutionRulesConfiguration';
import SolutionRuleConfigurationEditModal from './SolutionRuleConfigurationEditModal';

type Props = {
  item: SolutionRuleConfigurationItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function SolutionRuleConfigurationCreateContainer({
  item,
  open,
  onClose,
}: Props) {
  const { showAlert } = useAlert();
  const { solutionId } = useParams();
  const solutionName = useCurrentSolutionName();

  const [onSubmit, loading] = useStatefulApi(
    (params) =>
      pepApiRequest({
        method: RequestMethod.Post,
        url: generateApiPath(API_POST_RULE_CONFIGURATION, { solutionId }),
        params,
      }),
    (res, params) => {
      showAlert({
        type: AlertType.Success,
        title: 'Rule Configuration created',
        text: `${params.name} Rule Configuration has been created successfully.`,
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  return (
    <SolutionRuleConfigurationEditModal
      title="Create new rule"
      open={open}
      onClose={onClose}
      onSubmit={onSubmit}
      loading={loading}
    />
  );
}

export default SolutionRuleConfigurationCreateContainer;
